import { render, staticRenderFns } from "./DatabaseIcon.vue?vue&type=template&id=5a9dc149&"
import script from "./DatabaseIcon.vue?vue&type=script&lang=ts&"
export * from "./DatabaseIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports